export const prettifyRouteKey = (key: string) => {
  return key
    .replaceAll(/^\/+/g, '')
    .replaceAll('@', '')
    .replaceAll(/[/-]/g, '_')
    .replace(/^src_pages_/, '');
};
